export const Colors = {
  primary: '#E2001A',
  primaryDarker: '#D50C0C',
  primaryLighter: '#ffe7ea',
  background: '#F8F8F8',
  textColor: '#000000',
  borderColor: '#DEDEDE',

  white: '#ffffff',
  black: '#000000',
  grey: '#C7C7C7',
  dark: '#6d6d6d',

  danger: '#E2001A',
  success: '#2ba75c',
  warning: '#ff9800'
};
